export const cleanWasteCode = wasteCode => {
  const NOT_DIGIT_OR_STAR_REGEX = /[^\d*]/gm
  const updatedValue = wasteCode.replace(NOT_DIGIT_OR_STAR_REGEX, '')
  return updatedValue
}
